"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportTravelTimeForm = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const components_1 = require("../../../../components");
const Flex_1 = require("@amzn/atoz-web/Flex");
const View_1 = require("@amzn/atoz-web/View");
const Datepicker_1 = require("@amzn/atoz-web/Datepicker");
const luxon_1 = require("luxon");
const Text_1 = require("@amzn/atoz-web/Text");
const InputWrapper_1 = require("@amzn/atoz-web/InputWrapper");
const context_1 = require("../../../../components/UnscheduledWorkWorkflow/context");
const useReportTravelTimeStep_1 = require("./hooks/useReportTravelTimeStep");
const MessageBanner_1 = require("@amzn/atoz-web/MessageBanner");
const Modal_1 = require("@amzn/atoz-web/Modal");
const Button_1 = require("@amzn/atoz-web/Button");
const components_2 = require("../../../../components");
const utils_1 = require("../../../../utils");
const logger_1 = require("../../../../logger");
const ReportTravelTimeForm = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { associateInfo, setTravelEndDate, setTravelStartDate, setTravelStartTime, setTravelEndTime, isMealBreakApplicable, setReasonForTravel, setMealBreakStartTime, setIsMealBreakApplicable, setDuration, setMealBreakEndTime, setMealBreakDuration } = (0, context_1.useUnscheduledWorkflowContext)();
    const { newTravelStartDate, newTravelStartTime, newTravelEndDate, newTravelEndTime, newMealBreakStartTime, newReasonForTravel, setNewTravelStartDate, setNewTravelEndDate, setNewTravelEndTime, setNewTravelStartTime, setNewMealBreakStartTime, setNewReasonForTravel, hasInputError, setHasInputError, inputErrorMessage, setInputErrorMessage, setNewMealBreakEndTime, setNewMealBreakDuration, newMealBreakDuration } = (0, useReportTravelTimeStep_1.useReportTravelTimeStep)();
    const firstUpdate = (0, react_1.useRef)(true);
    (0, react_1.useEffect)(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
            return;
        }
        validate();
    }, [
        newTravelStartDate,
        newTravelStartTime,
        newTravelEndDate,
        newTravelEndTime,
        newMealBreakStartTime,
        newMealBreakDuration,
        newReasonForTravel
    ]);
    (0, logger_1.useComponentLoadedMetrics)({
        metricNames: {
            countMetricName: logger_1.METRICS.REPORT_TRAVEL_TIME_PAGE_RENDERED.COUNT
        },
        isComponentLoaded: true
    });
    (0, react_1.useEffect)(() => {
        utils_1.BIAnalytics.arriveReportTravelTimeStepInRTTW();
    }, []);
    const validate = () => {
        var _a;
        if (!(0, components_2.validateDate)(newTravelStartDate) || !(0, components_2.validateDate)(newTravelEndDate)) {
            return false;
        }
        setTravelStartDate(newTravelStartDate);
        setTravelEndDate(newTravelEndDate);
        const isInvalid = !(0, components_2.validate12HourFormatTime)(newTravelEndTime || '') ||
            !(0, components_2.validate12HourFormatTime)(newTravelStartTime);
        if (isInvalid) {
            setHasInputError(true);
            const errorMessage = t('unscheduled_work_invalid_time_format_error');
            setInputErrorMessage(errorMessage);
            return false;
        }
        const parsedTravelStartDateTime = (0, components_2.parseTravelTime)(newTravelStartTime || '', newTravelStartDate, false);
        const parsedTravelEndDateTime = (0, components_2.parseTravelTime)(newTravelEndTime || '', newTravelEndDate, false);
        if (parsedTravelStartDateTime >= luxon_1.DateTime.now() ||
            parsedTravelEndDateTime >= luxon_1.DateTime.now()) {
            setHasInputError(true);
            const errorMessage = t('unscheduled_work_future_date_selection_error');
            setInputErrorMessage(errorMessage);
            return false;
        }
        if (parsedTravelStartDateTime >= parsedTravelEndDateTime) {
            setHasInputError(true);
            const errorMessage = t('unscheduled_work_start_time_end_time_error');
            setInputErrorMessage(errorMessage);
            return false;
        }
        else {
            setTravelStartTime(newTravelStartTime);
            setTravelEndTime(newTravelEndTime);
            const durationObject = parsedTravelEndDateTime.diff(parsedTravelStartDateTime, ['hours']);
            const durationHours = (_a = durationObject === null || durationObject === void 0 ? void 0 : durationObject.toObject()) === null || _a === void 0 ? void 0 : _a.hours;
            if (durationHours >= 24) {
                setHasInputError(true);
                const errorMessage = t('unscheduled_work_travel_duration_error');
                setInputErrorMessage(errorMessage);
                return false;
            }
            let mealBreakApplicableCheck = false;
            if (associateInfo.region === 'USA-CA' &&
                durationHours &&
                durationHours >= 5) {
                mealBreakApplicableCheck = true;
                setIsMealBreakApplicable(true);
            }
            else {
                setNewMealBreakDuration(undefined);
                setNewMealBreakStartTime(undefined);
                setIsMealBreakApplicable(false);
            }
            if (mealBreakApplicableCheck &&
                newMealBreakStartTime &&
                (0, components_2.validate12HourFormatTime)(newMealBreakStartTime)) {
                if (!newMealBreakDuration) {
                    setHasInputError(true);
                    const errorMessage = t('unscheduled_work_meal_duration_missing_error');
                    setInputErrorMessage(errorMessage);
                    return false;
                }
                if (parseInt(newMealBreakDuration) < 30) {
                    setHasInputError(true);
                    const errorMessage = t('unscheduled_work_meal_duration_error');
                    setInputErrorMessage(errorMessage);
                    return false;
                }
                const mealStartTimeDiff = (0, components_2.calculateTimeDifferenceBetween12HourStrings)(newTravelStartTime, newMealBreakStartTime);
                if (mealStartTimeDiff >= durationHours) {
                    setHasInputError(true);
                    const errorMessage = t('unscheduled_work_meal_start_or_end_time_outside_travel_time_error');
                    setInputErrorMessage(errorMessage);
                    return false;
                }
                const mealBreakEndTimeCalculated = (0, components_2.addTimeTo12HourFormat)(newMealBreakStartTime, 0, parseInt(newMealBreakDuration));
                if (mealStartTimeDiff + parseInt(newMealBreakDuration) / 60 >
                    durationHours) {
                    setHasInputError(true);
                    const errorMessage = t('unscheduled_work_meal_duration_exceeds_travel_time_error');
                    setInputErrorMessage(errorMessage);
                    return false;
                }
                setMealBreakStartTime(newMealBreakStartTime);
                setMealBreakDuration(newMealBreakDuration);
                setNewMealBreakEndTime(mealBreakEndTimeCalculated);
                setMealBreakEndTime(mealBreakEndTimeCalculated);
            }
            setDuration(durationHours || 0);
        }
        if (!newReasonForTravel) {
            setHasInputError(true);
            const errorMessage = t('unscheduled_work_reason_for_travel_is_missing_error');
            setInputErrorMessage(errorMessage);
            return false;
        }
        setReasonForTravel(newReasonForTravel.trim());
        setHasInputError(false);
        return true;
    };
    const isDateDisabled = (date) => {
        const dateTime = luxon_1.DateTime.fromISO(date);
        return dateTime >= luxon_1.DateTime.now();
    };
    const renderModal = ({ close }) => {
        return (react_1.default.createElement(Modal_1.ModalContent, { dataTestId: components_2.UNSCHEDULED_WORK_WF_DATA_TEST_IDS.POLICY_STATEMENT_MODAL, titleText: t('unscheduled_work_policy_modal_heading'), buttons: [
                react_1.default.createElement(Button_1.Button, { variant: Button_1.ButtonVariant.Primary, onClick: close, key: 'close_modal_button_unscheduled' }, t('time_and_attendance_generic_close_label'))
            ] },
            react_1.default.createElement(Flex_1.Flex, { flexDirection: 'column', margin: { bottom: 300 }, gridGap: 'S400' },
                react_1.default.createElement(Text_1.Text, null, t('unscheduled_work_policy_modal_paragraph1')),
                react_1.default.createElement(Text_1.Text, { fontWeight: 'bold', fontSize: 'T300' }, t('unscheduled_work_policy_home_to_work')),
                react_1.default.createElement(Text_1.Text, null, t('unscheduled_work_policy_home_to_work_description')),
                react_1.default.createElement(Text_1.Text, null,
                    react_1.default.createElement("strong", null,
                        t('unscheduled_work_policy_generic_example_keyword'),
                        " :"),
                    react_1.default.createElement("span", null, t('unscheduled_work_policy_home_to_work_scenario1'))),
                react_1.default.createElement(Text_1.Text, null,
                    react_1.default.createElement("strong", null,
                        t('unscheduled_work_policy_generic_example_keyword'),
                        " :"),
                    react_1.default.createElement("span", null, t('unscheduled_work_policy_home_to_work_scenario1_continued'))),
                react_1.default.createElement(Text_1.Text, { fontWeight: 'bold', fontSize: 'T300' }, t('unscheduled_work_policy_travel_away_from_regular_worksite')),
                react_1.default.createElement(Text_1.Text, null, t('unscheduled_work_policy_travel_away_from_regular_worksite_description')),
                react_1.default.createElement(Text_1.Text, null,
                    react_1.default.createElement("strong", null,
                        t('unscheduled_work_policy_generic_example_keyword'),
                        " :"),
                    react_1.default.createElement("span", null, t('unscheduled_work_policy_travel_away_from_regular_worksite_scenario1'))),
                react_1.default.createElement(Text_1.Text, null,
                    react_1.default.createElement("strong", null,
                        t('unscheduled_work_policy_leaving_from_home'),
                        " :"),
                    react_1.default.createElement("span", null, t('unscheduled_work_policy_leaving_from_home_description'))),
                react_1.default.createElement(Text_1.Text, null,
                    react_1.default.createElement("strong", null,
                        t('unscheduled_work_policy_generic_example_keyword'),
                        " :"),
                    react_1.default.createElement("span", null, t('unscheduled_work_policy_leaving_from_home_scenario1'))),
                react_1.default.createElement(Text_1.Text, null,
                    react_1.default.createElement("strong", null,
                        t('unscheduled_work_policy_leaving_from_amazon_facility'),
                        " :"),
                    react_1.default.createElement("span", null, t('unscheduled_work_policy_leaving_from_amazon_facility_description'))),
                react_1.default.createElement(Text_1.Text, null,
                    react_1.default.createElement("strong", null,
                        t('unscheduled_work_policy_generic_example_keyword'),
                        " :"),
                    react_1.default.createElement("span", null, t('unscheduled_work_policy_leaving_from_amazon_facility_scenario1'))),
                react_1.default.createElement(Text_1.Text, null, t('unscheduled_work_policy_leaving_from_amazon_facility_scenario1_continued')),
                react_1.default.createElement(Text_1.Text, null, t('unscheduled_work_policy_general_statement1')),
                react_1.default.createElement(Text_1.Text, null, t('unscheduled_work_policy_general_statement2')),
                react_1.default.createElement(Text_1.Text, null, t('unscheduled_work_policy_general_statement3')))));
    };
    return (react_1.default.createElement(components_1.SpinnerOverlay, { isLoading: false },
        react_1.default.createElement(Flex_1.Flex, { flexDirection: 'column' },
            react_1.default.createElement(Flex_1.Flex, { flexDirection: 'row', margin: { top: 'S300' }, gridGap: 'S200', flexWrap: 'wrap' },
                react_1.default.createElement(Text_1.Text, null, t(`unscheduled_work_report_travel_if_eligible_description`)),
                react_1.default.createElement(Modal_1.WithModal, { renderModal: renderModal, shouldCloseOnClickOutside: true }, ({ open }) => (react_1.default.createElement(Text_1.Text, { dataTestId: components_2.UNSCHEDULED_WORK_WF_DATA_TEST_IDS.READ_POLICY, color: 'primary70', onClick: open }, t(`unscheduled_work_report_travel_read_policy`))))),
            react_1.default.createElement(Flex_1.Flex, { flexDirection: 'column', dataTestId: components_2.UNSCHEDULED_WORK_WF_DATA_TEST_IDS.UNSCHEDULED_WORK_REPORTING_FORM, gridGap: 'S300', margin: { top: 'S300' } },
                react_1.default.createElement(Text_1.Label, { fontWeight: 'regular' }, t('unscheduled_work_report_travel_start_time')),
                react_1.default.createElement(Flex_1.Flex, { flexDirection: 'row', gridGap: 'S200' },
                    react_1.default.createElement(View_1.View, { width: '70%' },
                        react_1.default.createElement(Datepicker_1.PopupDatePicker, { isDateDisabled: isDateDisabled, name: 'travelStartDate', value: (newTravelStartDate === null || newTravelStartDate === void 0 ? void 0 : newTravelStartDate.toISODate()) || '', onChange: (value) => {
                                utils_1.BIAnalytics.changeTravelStartDateInReportTravelTimeWorkflow();
                                setNewTravelStartDate(luxon_1.DateTime.fromISO(value));
                            }, inputProps: {
                                width: '100%',
                                error: newTravelStartDate && !newTravelStartDate.isValid,
                                'aria-label': t('report_travel_time_workflow_aria_label_travel_start_date')
                            }, dataTestId: components_2.UNSCHEDULED_WORK_WF_DATA_TEST_IDS.TRAVEL_START_DATE })),
                    react_1.default.createElement(View_1.View, { className: "atoz-filter-text-time-input", flexGrow: 1 },
                        react_1.default.createElement(components_1.TextTimeInput, { onChange: (value) => {
                                utils_1.BIAnalytics.changeTravelStartTimeInReportTravelTimeWorkflow();
                                setNewTravelStartTime(value.trim());
                            }, value: newTravelStartTime || '', dataTestId: components_2.UNSCHEDULED_WORK_WF_DATA_TEST_IDS.TRAVEL_START_TIME, placeholder: t('time_and_attendance_PunchModal_EnterTime'), militaryTime: false, ariaLabel: t('report_travel_time_workflow_aria_label_travel_start_time') })))),
            react_1.default.createElement(Flex_1.Flex, { flexDirection: 'column', gridGap: 'S300', margin: { top: 'S300' } },
                react_1.default.createElement(Text_1.Label, { fontWeight: 'regular' }, t('unscheduled_work_report_travel_end_time')),
                react_1.default.createElement(Flex_1.Flex, { flexDirection: 'row', gridGap: 'S200' },
                    react_1.default.createElement(View_1.View, { width: '70%' },
                        react_1.default.createElement(Datepicker_1.PopupDatePicker, { isDateDisabled: isDateDisabled, name: 'travelEndDate', value: (newTravelEndDate === null || newTravelEndDate === void 0 ? void 0 : newTravelEndDate.toISODate()) || '', onChange: (value) => {
                                utils_1.BIAnalytics.changeTravelEndDateInReportTravelTimeWorkflow();
                                setNewTravelEndDate(luxon_1.DateTime.fromISO(value));
                            }, inputProps: {
                                width: '100%',
                                error: newTravelEndDate && !newTravelEndDate.isValid,
                                'aria-label': t('report_travel_time_workflow_aria_label_travel_end_date')
                            }, dataTestId: components_2.UNSCHEDULED_WORK_WF_DATA_TEST_IDS.TRAVEL_END_DATE })),
                    react_1.default.createElement(View_1.View, { className: "atoz-filter-text-time-input", flexGrow: 1 },
                        react_1.default.createElement(components_1.TextTimeInput, { onChange: (value) => {
                                utils_1.BIAnalytics.changeTravelEndTimeInReportTravelTimeWorkflow();
                                setNewTravelEndTime(value.trim());
                            }, value: newTravelEndTime || '', placeholder: t('time_and_attendance_PunchModal_EnterTime'), militaryTime: false, ariaLabel: t('report_travel_time_workflow_aria_label_travel_end_time'), dataTestId: components_2.UNSCHEDULED_WORK_WF_DATA_TEST_IDS.TRAVEL_END_TIME })))),
            isMealBreakApplicable && (react_1.default.createElement(Flex_1.Flex, { flexDirection: 'column', dataTestId: components_2.UNSCHEDULED_WORK_WF_DATA_TEST_IDS.MEAL_BREAK_APPLICABLE_VIEW, gridGap: 'S300', margin: { top: 'S300' } },
                react_1.default.createElement(Flex_1.Flex, { flexDirection: 'row', gridGap: 'S400' },
                    react_1.default.createElement(View_1.View, null,
                        react_1.default.createElement(Text_1.Text, { fontSize: 'T200', fontWeight: 'bold' }, t(`unscheduled_work_report_travel_meal_break_heading`)),
                        react_1.default.createElement(Text_1.P, null, t('unscheduled_work_report_travel_meal_break_policy')))),
                react_1.default.createElement(Flex_1.Flex, { flexDirection: 'row', gridGap: 'S400', flexWrap: "wrap" },
                    react_1.default.createElement(View_1.View, { width: '30%' },
                        react_1.default.createElement(Text_1.Label, { fontWeight: 'regular' }, t('unscheduled_work_report_travel_meal_start_time_label')),
                        react_1.default.createElement(components_1.TextTimeInput, { onChange: (value) => {
                                utils_1.BIAnalytics.changeTravelMealStartTimeInReportTravelTimeWorkflow();
                                setNewMealBreakStartTime(value.trim());
                            }, value: newMealBreakStartTime || '', placeholder: t('time_and_attendance_PunchModal_EnterTime'), militaryTime: false, ariaLabel: t('report_travel_time_workflow_aria_label_meal_break_start_time'), dataTestId: components_2.UNSCHEDULED_WORK_WF_DATA_TEST_IDS.MEAL_BREAK_START_TIME })),
                    react_1.default.createElement(View_1.View, { width: '30%' },
                        react_1.default.createElement(Text_1.Label, { htmlFor: 'meal-break-duration', fontWeight: 'regular' }, t('unscheduled_work_report_travel_meal_duration_label')),
                        react_1.default.createElement(InputWrapper_1.Input, { id: "meal-break-duration", type: "number", name: "mealBreakDuration", value: newMealBreakDuration, onChange: (event) => {
                                var _a;
                                utils_1.BIAnalytics.changeTravelMealDurationInReportTravelTimeWorkflow();
                                setNewMealBreakDuration((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value);
                            }, dataTestId: components_2.UNSCHEDULED_WORK_WF_DATA_TEST_IDS.MEAL_BREAK_END_TIME }))))),
            react_1.default.createElement(Flex_1.Flex, { flexDirection: 'column', gridGap: 'S300', margin: { top: 'S300' } },
                react_1.default.createElement(Flex_1.Flex, { flexDirection: 'row', gridGap: 'S200' },
                    react_1.default.createElement(View_1.View, { width: '100%' },
                        react_1.default.createElement(InputWrapper_1.InputHeader, { labelText: t('unscheduled_work_report_travel_reason_for_travel_label'), htmlFor: "reason-for-travel", required: true }),
                        react_1.default.createElement(InputWrapper_1.Input, { id: "reason-for-travel", dataTestId: components_2.UNSCHEDULED_WORK_WF_DATA_TEST_IDS.REASON_FOR_TRAVEL_INPUT, type: "text", name: "reasonForTravel", value: newReasonForTravel, placeholder: t('unscheduled_work_report_travel_reason_for_travel_placeholder'), onChange: (event) => {
                                var _a;
                                utils_1.BIAnalytics.changeTravelReasonInReportTravelTimeWorkflow();
                                setNewReasonForTravel((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value);
                            }, minWidth: '100%' })))),
            hasInputError && (react_1.default.createElement(Flex_1.Flex, { flexDirection: 'row', gridGap: 'S200', margin: { top: 'S200' } },
                react_1.default.createElement(View_1.View, { width: '100%' },
                    react_1.default.createElement(MessageBanner_1.MessageBanner, { dataTestId: components_2.UNSCHEDULED_WORK_WF_DATA_TEST_IDS.REPORT_TRAVEL_TIME_INPUT_ERROR_BANNER, iconAltText: t('time_and_attendance_Error'), type: MessageBanner_1.MessageBannerType.Error }, inputErrorMessage)))),
            react_1.default.createElement(Flex_1.Flex, { flexDirection: 'column', dataTestId: components_2.UNSCHEDULED_WORK_WF_DATA_TEST_IDS.ACKNOWLEDGMENT_SECTION, gridGap: 'S300', margin: { top: 'S500' } },
                react_1.default.createElement(Flex_1.Flex, { flexDirection: 'row', gridGap: 'S200' },
                    react_1.default.createElement(View_1.View, { flexGrow: 1 },
                        react_1.default.createElement(Text_1.P, null, t('unscheduled_work_report_travel_acknowledgment_description'))))))));
};
exports.ReportTravelTimeForm = ReportTravelTimeForm;
